import { connect } from "react-redux";
import React, { Component } from "react";

import { ContainerContent } from "@/components/Common/Dashboard/ContainerContent";
import { ContainerTitle } from "@/components/Common/Dashboard/ContainerTitle";
import {
  getInsuranceImagePresignedUrl,
  INSURANCE_IMAGE_FILE_PRIMARY_BACK_SUB_TYPE,
  INSURANCE_IMAGE_FILE_PRIMARY_FRONT_SUB_TYPE,
  INSURANCE_IMAGE_FILE_SECONDARY_BACK_SUB_TYPE,
  INSURANCE_IMAGE_FILE_SECONDARY_FRONT_SUB_TYPE,
  PATIENT_INSURANCE_IMAGE_FILE_TYPE,
  REFERRAL_INSURANCE_IMAGE_FILE_TYPE,
} from "@/utils/fileUtil";
import PatientProfileInsurance from "@/components/Patient/Profile/PatientProfileInsurance";
import { patientRequests } from "@/api/(requests)/patient";
import ProfileLoader from "@/components/Common/Loaders/ProfileLoader";
import { setDynamicRouteConfiguration } from "@/redux/actions/navbar";

class PatientInsurance extends Component {
  state = {
    insuranceImageStatuses: {
      pbStatus: null,
      pfStatus: null,
      sbStatus: null,
      sfStatus: null,
    },
    insuranceImageTypes: {
      pbType: null,
      pfType: null,
      sbType: null,
      sfType: null,
    },
    insuranceImageUrls: {
      pbUrl: null,
      pfUrl: null,
      sbUrl: null,
      sfUrl: null,
    },
    patientAvatar: null,
    patientProfile: null,
  };

  componentDidMount() {
    const dynamicRouteConfig = {};

    dynamicRouteConfig["logoSection"] = { title: "Profile" };
    this.props.setDynamicRouteConfiguration(dynamicRouteConfig);
    this.getProfile();
  }

  componentWillUnmount() {
    this.props.setDynamicRouteConfiguration({});
  }

  getProfile = async () => {
    try {
      let response = await patientRequests.fetch_profile({ context: { showLoader: false } });

      this.setState({
        patientProfile: response && response.user,
      });

      loadPatientInsuranceImagesUrlToState(response.user, this);
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    return (
      <ContainerContent>
        <ContainerTitle title="Insurance" />

        {this.state.patientProfile ? (
          <PatientProfileInsurance
            insuranceImageStatuses={this.state.insuranceImageStatuses}
            insuranceImageTypes={this.state.insuranceImageTypes}
            insuranceImageUrls={this.state.insuranceImageUrls}
            profileData={this.state.patientProfile}
            reloadImg={(user) => loadPatientInsuranceImagesUrlToState(user, this)}
          />
        ) : (
          <ProfileLoader />
        )}
      </ContainerContent>
    );
  }
}

export default connect(null, { setDynamicRouteConfiguration })(PatientInsurance);

export const loadPatientInsuranceImagesUrlToState = (patient, that) => {
  loadInsuranceImagesUrlToState(patient.username, patient, PATIENT_INSURANCE_IMAGE_FILE_TYPE, that);
};

export const loadReferralInsuranceImagesUrlToState = (referral, that) => {
  loadInsuranceImagesUrlToState(
    referral.referralCode,
    referral,
    REFERRAL_INSURANCE_IMAGE_FILE_TYPE,
    that,
  );
};

const loadInsuranceImagesUrlToState = (entityId, entity, fileType, that) => {
  fetchInsuranceImages(entityId, entity, fileType).then(([pfUrl, pbUrl, sfUrl, sbUrl]) =>
    spreadImages(pfUrl, pbUrl, sfUrl, sbUrl, that),
  );
};

const fetchInsuranceImages = (entityId, entity, fileType) => {
  let prIns = entity.primary_insurance;
  let secIns = entity.secondary_insurance;

  let pf = prIns.card_front; //primary front
  let pb = prIns.card_back; // primary back
  let sf = secIns.card_front; // secondary front
  let sb = secIns.card_back; // secondary back

  return Promise.all([
    getImage(entityId, pf, fileType, INSURANCE_IMAGE_FILE_PRIMARY_FRONT_SUB_TYPE),
    getImage(entityId, pb, fileType, INSURANCE_IMAGE_FILE_PRIMARY_BACK_SUB_TYPE),
    getImage(entityId, sf, fileType, INSURANCE_IMAGE_FILE_SECONDARY_FRONT_SUB_TYPE),
    getImage(entityId, sb, fileType, INSURANCE_IMAGE_FILE_SECONDARY_BACK_SUB_TYPE),
  ]);
};

const spreadImages = (pfUrl, pbUrl, sfUrl, sbUrl, that) => {
  that.setState({
    insuranceImageUrls: {
      pbUrl: pbUrl.message,
      pfUrl: pfUrl.message,
      sbUrl: sbUrl.message,
      sfUrl: sfUrl.message,
    },
  });

  that.setState({
    insuranceImageTypes: {
      pbType: pbUrl.content_type,
      pfType: pfUrl.content_type,
      sbType: sbUrl.content_type,
      sfType: sfUrl.content_type,
    },
  });

  that.setState({
    insuranceImageStatuses: {
      pbStatus: pbUrl.status,
      pfStatus: pfUrl.status,
      sbStatus: sbUrl.status,
      sfStatus: sfUrl.status,
    },
  });
};

/**
 * Returns a promise resolving to presigned URL data, or { message: null } for missing keys.
 */
const getImage = (username, fileKey, fileType, fileSubType) => {
  if (!fileKey || fileKey.trim() === "" || fileKey === "None") {
    return new Promise((resolve) => {
      resolve({ message: null });
    });
  }

  return getInsuranceImagePresignedUrl(username, fileType, fileSubType);
};
